import React from 'react';

import { Button } from 'components/ui/button';

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export type AddTagButtonProps = {
  buttonClasses?: string;
  extraLabel?: string;
  variant?: React.ComponentProps<typeof Button>['variant'];
  icon?: IconDefinition;
  iconEnd?: IconDefinition;
}

export default function AddTagButton({ buttonClasses, extraLabel, variant, icon, iconEnd }: AddTagButtonProps) {
  return (
    <Button className={buttonClasses} icon={icon} iconEnd={iconEnd} variant={variant || 'outline'}>
      Add Tag {extraLabel}
    </Button>
  );
}
